import React from 'react'
import RootModel from '../models/RootModel/RootModel'
import Path from '../components/Path/Path'

const PathPage = () => {
  return (
    <div>
        <RootModel navigateTo={-1}>
            <Path/>
        </RootModel>
    </div>
  )
}

export default PathPage